@if (details(); as details) {
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <p-button
        icon="pi pi-refresh"
        (onClick)="loadDetails()"
        [label]="'general.refresh' | translate"
        styleClass="mr--4"
        [pTooltip]="lastUpdate() | dayjs: 'L, LT' : true"
        tooltipPosition="top"
        variant="text"
      />

      @if (details.carrierTrackingUrl) {
        <p-button
          icon="pi pi-globe"
          (onClick)="openUrl(details.carrierTrackingUrl)"
          [label]="'pages.transport.tracking-tabs.open-carrier-page' | translate"
          styleClass="mr--4"
          link
        />
      }
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <transport-details [details]="details"></transport-details>
    </div>
  </div>
}

@if (errorMessage(); as error) {
  <div class="row">
    <div class="col-12 mt--64 mb--64">
      <myarvato-error-message [summary]="error.summary" [details]="error.detail"></myarvato-error-message>
    </div>
  </div>
}
